import $ from 'jquery';
import watch from 'redux-watch';

import template from 'intl-shipping-information.j2';
import templateUK from 'eu-shipping-information-table.j2';
import { generate } from '../../../core/js/utils/componentUtils';
import { handleChangeSelectedIntlShippingCountry, getShippingInformationData } from '../utils/intlShippingUtils';

/**
 * Bootstrap the component onto the page
 * @returns {undefined}
 */
export function init(store, overrides = {}){
    const config = {
        templateLocation: '.dom-intl-shipping',
        className: 'dom-intl-shipping',
        watch: 'help.selectedCountry',
        name: 'intlShippingInfoComponent',
        attachEvents: attachEvents,
        template: store.getState().core.siteId === 'an-uk' ? templateUK : template,
        generateDictionary: generateDictionary,
        firstRender: firstRender
    };

    return generate(config, store, overrides);
}

export function firstRender(store) {
    const dictionary = this.generateDictionary(store.getState(), {}, this);
    this.render(store, this, dictionary);
}

export function initialize(store) {
    attachEvents(store);
}

function generateDictionary(state, dict, config) {
    const shippingInformationData = getShippingInformationData(state);
    const data = {
        frequentlySelectedCountries: shippingInformationData.frequentlySelectedCountries,
        allOtherCountries: shippingInformationData.allOtherCountries
    };

    return Object.assign({}, state, data);
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
export function attachEvents(store) {
    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-shipping-country-select'), (e) => {
        handleChangeSelectedIntlShippingCountry(store, e);
    });
}
